<template>
  <div>
    <span>
      <tool-tip style="float: right;z-index: -1;" v-on:updateToolTip="updateToolTip($event)"
        v-if="preOrderDetail_tooltip_NAME" :name="preOrderDetail_tooltip_NAME"
        :description="preOrderDetail_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    </span>
    <br /> <br />
    <div class="row justify-content-center">
      <div  class="col-sm-6 more-top-padding">
        <label for="organizationResponsibleForOrder">Organization Responsible for order<span
            class="red">(Required)</span></label>

        <div  :class="['row dropdown_select_container', !isEditable ? 'view_only' : '']">
            <treeselect v-if="isEditable"  :disabled="isReadOnly || isPartnerAccount" v-model="preOrder.organizationId"
              class="select-primary" name="preOrderOrganization" v-validate="'required'" data-vv-as="Organization"
              :multiple="false" :clearable="true" :searchable="true" :open-on-click="true" :open-on-focus="false"
              :clear-on-select="false" :close-on-select="true" :always-open="false" :append-to-body="false"
              search-nested :class="errors.has('preOrderOrganization') ? 'has-danger' : ''"
              :options="filteredOrganizations" />
             
            
          
          <p v-if="!isEditable" class="dropdown_text_wrap"> {{ selectedOrganization }} </p>

          <el-button style="margin-left:10px" size="mini" :class="isEditable ? 'editing' : 'btn-secondary'"
            v-show="!isReadOnly" :icon="isEditable ? 'el-icon-close' : 'el-icon-edit'"
            @click="toggleEdit()"></el-button>

        </div>
        <span v-show="errors.has('preOrderOrganization')" class="error"> {{ errors.first("preOrderOrganization") }}
            </span>
          
      </div>


      <div class="col-sm-6 more-top-padding">
        <label for="usByOrSell">Is the US the Buying or Selling party in the transaction?
          <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="isBuySellToolTip_Name"
            :name="isBuySellToolTip_Name" :description="isBuySellToolTip_Description" :editable="editable"></tool-tip>
        </label>

        <br />
        <el-radio-group v-validate="'required'" data-vv-as="U.S. Buy / Sell" name="buySell" :error="getError('buySell')"
          v-model="preOrder.usBuySell" :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount">
          <el-radio v-for="buySellOption in buySellOptions" :label="buySellOption.id" :key="buySellOption.id">{{
          buySellOption.name }}</el-radio>
        </el-radio-group>
        <br>
        <span v-show="errors.has('buySell')" class="error">{{ errors.first("buySell") }}
        </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-6 more-top-padding">
        <label for="methodOfPayment">Method of Payment</label>
        <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="ModeOfPayToolTip_Name" :name="ModeOfPayToolTip_Name"
          :description="ModeOfPayToolTip_Description" :editable="editable"></tool-tip>

        <br />
        <el-radio-group v-validate="'required'" data-vv-as="Method of Payment" name="paymentMethod"
          :error="getError('paymentMethod')" v-model="preOrder.paymentMethodId" :disabled="this.shouldEnable"
          @change="paymentMethodChanged">
          <el-radio tabindex="0" v-for="paymentMethod in paymentMethods" :label="paymentMethod.paymentMethodId"
            :key="paymentMethod.paymentMethodId">{{ paymentMethod.name | toLowercase }}</el-radio>
        </el-radio-group>
        <br>
        <span v-show="errors.has('paymentMethod')" class="error">{{ errors.first("paymentMethod") }}
        </span>
      </div>
      <div class="col-sm-6 more-top-padding">
        <span>
          <label for="naturalDisaster">Is this in support of a Theater-level Operation or Natural Disaster?
            <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="naturalDisastersToolTip_Name"
              :name="naturalDisastersToolTip_Name" :description="naturalDisastersToolTip_Description"
              :editable="editable"></tool-tip>
          </label>
          <br />
          <el-radio-group v-validate="'required'" data-vv-as="Theater-level Operation / Natural Disaster" name="naturalDisaster"
            :error="getError('naturalDisaster')" v-model="naturalDisaster"
            :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount">
            <el-radio v-for="yesNoOption in yesNoOptions" :label="yesNoOption.id" :key="yesNoOption.id">{{
          yesNoOption.name }}</el-radio>
          </el-radio-group>
          <br>
          <span v-show="errors.has('naturalDisaster')" class="error">{{ errors.first("naturalDisaster") }}
          </span>
          <br>
        </span>
        <br v-if="naturalDisaster === 'YES'" />
        <div v-if="naturalDisaster === 'YES'" class="more-top-padding">
          <label for="Category">Category:</label>
          <br />


          <v-select id="OrderCategoryId" data-vv-as="Order Category" v-validate="'required'"
            v-model="preOrder.orderCategoryId" label="name"
            :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount" :reduce="item => item.orderCategoryId"
            :options="orderCategories" placeholder="Select one" name="OrderCategoryId"
            :error="getError('OrderCategoryId')">

          </v-select>
          <span v-show="errors.has('OrderCategoryId')" class="error">{{ errors.first("OrderCategoryId") }}
          </span>
          <br>
        </div>
        <div class="more-top-padding">
          <label for="lsssType">LSSS Type</label>
          <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="SUBMIT_PREORDER_LSSSTYPE_NAME"
            :name="SUBMIT_PREORDER_LSSSTYPE_NAME" :description="SUBMIT_PREORDER_LSSSTYPE_DESCRIPTION"
            :editable="editable"></tool-tip>
          <br />
          <el-radio-group tabindex="0" v-validate="'required'" data-vv-as="LSSS Type" name="lsssType"
            :error="getError('lsssType')" v-model="preOrder.lssTypeId"
            :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount" @change="lsssTypeChanged">
            <el-radio v-for="lssType in lssTypes" :label="lssType.lssTypeId" :key="lssType.lssTypeId">{{ lssType.name
              }}</el-radio>
          </el-radio-group>
          <br>
          <span v-show="errors.has('lsssType')" class="error">{{ errors.first("lsssType") }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 more-top-padding">
        <label for="dodAac">DODAAC
          <span class="red">Letters I and O are not allowed</span>
          <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="DODAAC_TOOLTIP_NAME" :name="DODAAC_TOOLTIP_NAME"
            :description="DODAAC_TOOLTIP_DESCRIPTION" :editable="editable"></tool-tip>

        </label>
        <!-- Regex allows alphanumeric, and doesn't allow ioIO letters, and for some reason I have to set the max len
         equl 5 so that it is limiting only to 6 characters. If I set to 6, it will allow up to 7 characters -->
        <base-input id="dodAac" :disabled="isReadOnly || isPartnerAccount" v-model="preOrder.dodAac" name="DODAAC"
          v-validate="{ regex: /^[a-hj-np-zA-HJ-NP-Z0-9]{6}$/ }" data-vv-as="DODAAC"
          :error="getError('DODAAC')"></base-input>
      </div>
      <div v-if="!isPartnerAccount" class="col-sm-6 more-top-padding">
        <label for="ratificationForm">Is Ratification Required? 
          <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="RATIFICATION_TOOLTIP_NAME" :name="RATIFICATION_TOOLTIP_NAME"
            :description="RATIFICATION_TOOLTIP_DESCRIPTION" :editable="editable"></tool-tip>

        </label>
        <br/>
         <el-radio-group v-validate="'required'" data-vv-as="Ratification Required" name="isRatificationRequired"
            :error="getError('isRatificationRequired')" v-model="preOrder.isRatified"
            :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount">
            <el-radio v-for="yesNoOption in trueOrFalse" :label="yesNoOption.id" :key="yesNoOption.id">{{
          yesNoOption.name }}</el-radio>
          </el-radio-group>
          <br>
          <span v-show="errors.has('isRatificationRequired')" class="error">{{ errors.first("isRatificationRequired") }}
          </span>
          <br>
          <div v-if="preOrder.isRatified" >
          <label for="ratificationJustification">Ratification Justification</label>
          <br />
          <v-select id="ratificationJustification" data-vv-as="Ratification Justification" v-validate="'required'"
            v-model="preOrder.ratificationId" label="name"
            :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount" :reduce="item => item.ratificationId"
            :options="ratificationJustifications" placeholder="Select one" name="ratificationJustification"
            :error="getError('ratificationJustification')">

          </v-select>
          <span v-show="errors.has('ratificationJustification')" class="error">{{ errors.first("ratificationJustification") }}
          </span>
          <br>
        </div>
        <div v-if="preOrder.isRatified" >
          <br />    
          <label  for="descriptionOfCommitment">Description of Commitment</label> 
        <el-input id="descriptionOfCommitment" :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount"
          v-model="preOrder.ratificationJustification" name="descriptionOfCommitment"
          data-vv-as="Description of Commitment"
          placeholder="Description of commitment requiring ratification"
          v-validate='"required"'
          :rows="1"
          type="textarea" maxlength="500" show-word-limit>
        </el-input>
        <div>
          <span>{{ descriptionCharacterCountMessage }}</span>
        </div>
          <span v-show="errors.has('descriptionOfCommitment')" class="error">{{ errors.first("descriptionOfCommitment") }}
           </span> 
          <br>
        </div>
      </div>
      <div v-if="isMonetaryOrder" class="col-sm-6 more-top-padding">
        <label for="hasAcsaCeiling">Do ACSA Ceilings Apply?</label>
        <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="ASCACeilings_NAME" :name="ASCACeilings_NAME"
          :description="ASCACeilings_DESCRIPTION" :editable="editable"></tool-tip>
        <br />
        <base-input :error="getError('ACSA Ceilings')">

          <el-radio-group name="ACSA Ceilings" v-model="preOrder.hasAcsaCeiling"
            :disabled="isReadOnly || isOrderSubmitted || isPartnerAccount">
            <el-radio label="YES">Yes</el-radio>
            <el-radio label="NO">No</el-radio>
          </el-radio-group>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div v-if="isMonetaryOrder"   class="col-sm-6">
        <label  for="acsaCeilingsJustification">ACSA Ceiling Justification</label>
        <el-input id="acsaCeilingsJustification" :disabled="isReadOnly || isPartnerAccount"
          v-model="preOrder.acsaCeilingJustification" name="acsaCeilingJustification"
          data-vv-as="ACSA Ceiling Justification"
          v-validate.immediate="{ required: this.hasAcsaCeiling !== null && !this.hasAcsaCeiling, max: 250 }"
          type="text" maxlength="250" show-word-limit>
        </el-input>
        <div>
          <span>{{ acsaCeilingJustificationCharacterCountMessage }}</span>
        </div>
        <span v-show="errors.has('acsaCeilingJustification')" class="error">{{ errors.first("acsaCeilingJustification")
          }}
        </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 more-top-padding">
        <div class="pull-right">
          <base-button :disabled="isReadOnly || loading || isPartnerAccount" type="primary" wide @click.prevent="submit"
            class="btn-next">Save</base-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Select, Option, Radio, RadioGroup, Input, Button } from "element-ui";
import axios from '@/axios';
import Util from "../../../../util/util";
import toolTip from "../../Tooltip";
const SUCCESS_MESSAGE = "Pre Order Details Module Saved";
export default {
  props: ["isReadOnly"],
  name: "pre-order-detail",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Input.name]: Input,
    [Button.name]: Button,
    Treeselect,
    toolTip,
  },
  data() {
    return {
      loading: false,
      isEditable: false,
      SUBMIT_PREORDER_LSSSTYPE_NAME: '',
      DODAAC_TOOLTIP_NAME: '',
      DODAAC_TOOLTIP_DESCRIPTION: '',
      RATIFICATION_TOOLTIP_NAME: '',
      RATIFICATION_TOOLTIP_DESCRIPTION: '',
      SUBMIT_PREORDER_LSSSTYPE_DESCRIPTION: '',
      preOrderDetail_tooltip_NAME: '',
      preOrderDetail_tooltip_DESCRIPTION: '',
      isBuySellToolTip_Name: '',
      isBuySellToolTip_Description: '',
      ModeOfPayToolTip_Name: '',
      ModeOfPayToolTip_Description: '',
      naturalDisastersToolTip_Description: '',
      naturalDisastersToolTip_Name: '',
      ASCACeilings_NAME: '',
      ASCACeilings_DESCRIPTION: '',
      naturalDisaster: 'NO',
      isRatificationRequired: 'NO',
      value: null,
      buySellOptions: [
        {
          id: "BUY",
          name: "Buy",
        },
        {
          id: "SELL",
          name: "Sell",
        },
      ],
      yesNoOptions: [
        {
          id: "YES",
          name: "Yes",
        },
        {
          id: "NO",
          name: "No",
        },

      ],
      trueOrFalse:[
      {
          id: true,
          name: "Yes",
        },
        {
          id: false,
          name: "No",
        },
      ],
    };
  },
  async mounted() {
    this.$validator.reset();
    await this.getAllTooltips()
    this.preCheckAndClear()
    this.loadToolTips()
  },
  computed: {
    ...mapGetters({
      lssTypes: "lsstype/allLssTypes",
      flattenedOrganizations: "organization/flattenedOrganizations",
      filteredOrganizations: "organization/filteredOrganizations",
      organization: "organization/organization",
      paymentMethods: "paymentmethod/paymentMethods",
      orderCategories: "orders/orderCategories",
      ratificationJustifications: "orders/ratificationJustifications",
      preOrder: "preOrderDetail/preOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      preOrderErrors: "preOrderDetail/preOrderErrors",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      isSuperAdmin: "authentication/isSuperAdmin",
      user:  "authentication/getUser",
      logisticsUserId: "orderMetadata/logisticsUserId",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    shouldEnable() {
      return (this.isReadOnly || this.isOrderSubmitted || this.isPartnerAccount) && !this.isSuperAdmin;
    },
    orderId() {
      return this.$route.params.id;
    },
    isOrderSubmitted() {
      return this.orderMetadata.orderStatus !== Util.ORDER_STATUS_DRAFT;
    },
    selectedOrganization() {
      let ctx = this;
      let selected = null;

      if (ctx.preOrder.organizationId)
        selected = ctx.flattenedOrganizations.find(o => o.id === ctx.preOrder.organizationId);

      return selected ? selected.name : 'No organization  selected';
    },
    acsaCeilingJustificationCharacterCountMessage() {
      if (this.preOrder.acsaCeilingJustification && this.preOrder.acsaCeilingJustification.length != null) {
        return 250 - this.preOrder.acsaCeilingJustification.length + " Characters Remaining";
      } else {
        return "250 Characters Remaining";
      }
    },
    
    descriptionCharacterCountMessage() {
      if (this.preOrder.ratificationJustification && this.preOrder.ratificationJustification.length != null) {
        return 500 - this.preOrder.ratificationJustification.length + " Characters Remaining";
      } else {
        return "500 Characters Remaining";
      }
    },
    hasAcsaCeiling() {
      const YES = "YES"
      return this.preOrder.hasAcsaCeiling && this.preOrder.hasAcsaCeiling === YES
    }
  },
  filters: {
    toLowercase: function (value) {
      if (!value) return "";
      if (value === Util.MONETARY) {
        value = value.toString().toLowerCase();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
      return value;
    },
  },
  watch: {
    isRatificationRequired: function (newVal, oldVal) {
      this.order.isRatified = newVal
    }
  },
  methods: {
    ...mapActions({
      getLssTypes: "lsstype/getLssTypes",
      getPreOrder: "preOrderDetail/getPreOrder",
      getOrderByStatus: "orders/getOrderByStatus",
      getFlattenedOrganizations: "organization/getFlattenedOrganizations",
      getFilteredOrganizations: "organization/getFilteredOrganizations",
      getUserOrganization: "organization/getUserOrganization",
      getPaymentMethods: "paymentmethod/getPaymentMethods",
      getOrderCategories: "orders/getOrderCategories",
      getRatificationJustifications: "orders/getRatificationJustifications",
      savePreOrder: "preOrderDetail/savePreOrder",
      getPreOrderStatus: "preOrderDetail/getPreOrderStatus",
      updatePreOrderStatus: "preOrderDetail/updatePreOrderStatus",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      getLineItemReceiptStatus: "lineItemReceipt/getLineItemReceiptStatus",
      getDisbursingCollectionInformationStatus:
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
      getAllTooltips: "tooltip/getToolTips",
      getTransactionInformationStatus:
        "transactionInformation/getTransactionInformationStatus"
    }),
    showPreOrderErrors(response) {
      if (this.preOrderErrors.length > 0) {
        this.preOrderErrors.forEach(error => this.$toast.error(error))
      }
      else {
        if (Util.isString(response)) {
          // if it is completed order, response will be a string, otherwise, it is an orderId(int)
          this.$toast.success(response);
        } else {
          this.$toast.success(SUCCESS_MESSAGE);
        }
      }
    },
    preCheckAndClear() {
      if (this.preOrder.isOrderCategoryEnabled === undefined) {
        this.naturalDisaster = ''
        this.$validator.reset();
      } else {
        this.preOrder.isOrderCategoryEnabled ? this.naturalDisaster = 'YES' : this.naturalDisaster = 'NO'

      }
    },
    toggleEdit() {
      if (this.isEditable) {
        // this.orderMetadata.logisticsUserId = this.selectedOrganizationId
        this.isEditable = false
      } else {
        this.isEditable = true
        this.orderMetadata.logisticsUserId = ''
      }
    },
    loadToolTips() {
      const LssVal = this.toolTips.find(e => e.name === "LSSSType")
      const methodOfPaymentVal = this.toolTips.find(e => e.name === "MethodOfPayment")
      const isBuySellToolTipVal = this.toolTips.find(e => e.name === "IsBuySell")
      const preOrderDetailVal = this.toolTips.find(e => e.name === "PreOrderDetailsModule")
      const DODAAC_TOOLTIP = this.toolTips.find(e => e.name === "DODAAC")
      const naturalDisastersVal = this.toolTips.find(e => e.name === "NaturalDisasters")
      const ASCACeilings_TOOLTIP = this.toolTips.find(e => e.name === "ACSACeilings")
      const Ratification_Form_Tooltip =  this.toolTips.find(e => e.name === "RatificationForm")
      if (ASCACeilings_TOOLTIP && ASCACeilings_TOOLTIP.status) {
        this.ASCACeilings_NAME = ASCACeilings_TOOLTIP.name ? ASCACeilings_TOOLTIP.name : null
        this.ASCACeilings_DESCRIPTION = ASCACeilings_TOOLTIP.description ? ASCACeilings_TOOLTIP.description : null

      }
      if(Ratification_Form_Tooltip && Ratification_Form_Tooltip.status){
        this.RATIFICATION_TOOLTIP_NAME = Ratification_Form_Tooltip.name ? Ratification_Form_Tooltip.name : null
        this.RATIFICATION_TOOLTIP_DESCRIPTION = Ratification_Form_Tooltip.description ? Ratification_Form_Tooltip.description : null
      }
      if (DODAAC_TOOLTIP && DODAAC_TOOLTIP.status) {
        this.DODAAC_TOOLTIP_NAME = DODAAC_TOOLTIP.name ? DODAAC_TOOLTIP.name : null
        this.DODAAC_TOOLTIP_DESCRIPTION = DODAAC_TOOLTIP.description ? DODAAC_TOOLTIP.description : null

      }
      if (LssVal && LssVal.status) {
        this.SUBMIT_PREORDER_LSSSTYPE_DESCRIPTION = LssVal.description ? LssVal.description : null
        this.SUBMIT_PREORDER_LSSSTYPE_NAME = LssVal.name ? LssVal.name : null
      }
      if (naturalDisastersVal && naturalDisastersVal.status) {
        this.naturalDisastersToolTip_Name = naturalDisastersVal.name ? naturalDisastersVal.name : null;
        this.naturalDisastersToolTip_Description = naturalDisastersVal.description ? naturalDisastersVal.description : null;
      }
      if (methodOfPaymentVal && methodOfPaymentVal.status) {
        this.ModeOfPayToolTip_Name = methodOfPaymentVal.name ? methodOfPaymentVal.name : null
        this.ModeOfPayToolTip_Description = methodOfPaymentVal.description ? methodOfPaymentVal.description : null
      }
      if (isBuySellToolTipVal && isBuySellToolTipVal.status) {
        this.isBuySellToolTip_Description = isBuySellToolTipVal.description ? isBuySellToolTipVal.description : null
        this.isBuySellToolTip_Name = isBuySellToolTipVal.name ? isBuySellToolTipVal.name : null
      }
      if (preOrderDetailVal && preOrderDetailVal.status) {
        this.preOrderDetail_tooltip_DESCRIPTION = preOrderDetailVal.description ? preOrderDetailVal.description : null
        this.preOrderDetail_tooltip_NAME = preOrderDetailVal.name ? preOrderDetailVal.name : null
      }
      return

    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },

    loaded() {
      let ctx = this;

      let userid = ctx.orderId > 0 ? ctx.logisticsUserId : ctx.user.id;

      ctx.getOrderCategories();
      ctx.getRatificationJustifications();
      ctx.getLssTypes();
      ctx.getPaymentMethods();
      ctx.getPreOrder(ctx.orderId);
      
      ctx.getUserOrganization(userid)
        .then(() => ctx.getFilteredOrganizations(ctx.organization.id || 48))
        .then(() => ctx.getFlattenedOrganizations(48));
  
    },
    lsssTypeChanged(e) {
      if (this.preOrder.isFromBackend) {
        return;
      }

      if ((e === Util.STANDARD || e === Util.OPEN_ENDED) && this.preOrder.paymentMethodId === Util.MONETARY) {
        this.preOrder.hasAcsaCeiling = "YES"
        return;
      }

      if ((e === Util.SME_LOAN || e === Util.LIFT_AND_SUSTAIN || this.preOrder.lssTypeId === Util.STRATEGIC_AIRLIFT) && this.preOrder.paymentMethodId === Util.MONETARY) {
        this.preOrder.hasAcsaCeiling = "NO"
        return;
      }
    },
    paymentMethodChanged(e) {
      if (e === Util.MONETARY) {
        if (this.preOrder.lssTypeId === Util.STANDARD || this.preOrder.lssTypeId === Util.OPEN_ENDED) {
          this.preOrder.hasAcsaCeiling = "YES"
          return;
        }
        if (this.preOrder.lssTypeId === Util.SME_LOAN || this.preOrder.lssTypeId === Util.LIFT_AND_SUSTAIN || this.preOrder.lssTypeId === Util.STRATEGIC_AIRLIFT) {
          this.preOrder.hasAcsaCeiling = "NO"
          return;
        }
      }
      this.preOrder.hasAcsaCeiling = null;
      this.preOrder.acsaCeilingJustification = null;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    refreshStatus(orderId, response) {
      this.getPreOrderStatus(orderId).then(() => {
        this.showPreOrderErrors(response);
      });
      this.getPreOrder(orderId);
      this.getOrderByStatus({
        orderStatus: this.orderMetadata.orderStatus,
        id: orderId,
      });
      this.getReplacementItemStatus(orderId);
      this.getDisbursingCollectionInformationStatus(orderId);
      this.getLineItemReceiptStatus(orderId);
    },
    async submit(e) {
      if (this.naturalDisaster === 'YES') {
        this.preOrder.isOrderCategoryEnabled = true;
      } else {
        this.preOrder.isOrderCategoryEnabled = false; this.preOrder.orderCategoryId = null
      }
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          const ctx = this;
          ctx
            .savePreOrder()
            .then(async (response) => {
              this.loading = false;
              // new order save
              if (ctx.orderId <= 0) {

                ctx.getOrderMetadata(response);
                this.refreshStatus(response);
                ctx.$router.push({
                  name: "Order",
                  params: {
                    id: response,
                  },
                });
              } else {
                // either an update or a completed order case
                this.$validator.reset();
                this.refreshStatus(ctx.orderId, response);
                await this.getTransactionInformationStatus(ctx.orderId)
                this.showTransactionInfoErrors()

              }
            })
            .catch((errorMessage) => {
              this.loading = false;
            });
        } else {
          this.$toast.error("Please fill the required fields.");
          this.updatePreOrderStatus(false);        }
      });
    },
  },
};
</script>

<style scoped>
.has-danger:after {
  margin-right: 10px;
}



.vue-treeselect__x-container,
.vue-treeselect__control-arrow,
.vue-treeselect__single-value {
  color: #10b45a;
}

.white-content .form-group .el-input__inner[readonly] {
  background-color: transparent;
}

.el-radio__inner {
  border-color: #000;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #000 !important;
  background: #000;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #000;
}

.vue-treeselect div, .vue-treeselect span {
   
    max-width: 300px;
}
.vue-treeselect {
  max-width: 400px;
}
</style>
